'use strict';

const timeouts = new Map();

export default function debounce(callback, delay = 200) {
    return function () {
        let timeoutId = timeouts.get(callback);
        clearTimeout(timeoutId);

        const self = this;
        const args = arguments;
        timeoutId = setTimeout(function () {
            callback.apply(self, args);
        }, delay);

        timeouts.set(callback, timeoutId);
    };
}
